// extracted by mini-css-extract-plugin
export default {"periodSwitcher":"PeriodSwitcher_periodSwitcher__NDXvp","btn":"PeriodSwitcher_btn__Wl9sw","btnSelected":"PeriodSwitcher_btnSelected__3MqhW"};